/** ここ以下はグローバルナビをドロワーに切り替える（_variables.scss の $nav-bp と揃える） */
const DRAWER_QUERY = '(max-width: 1024px)';
const SCROLL_LOCK_CLASS = 'js-scroll-prevent';
const SCROLLED_CLASS = 'is-scrolled';
/** これ以上スクロールしたらヘッダーに背景を敷く */
const SCROLLED_OFFSET = 40;

/**
 * ヘッダーの高さを CSS カスタムプロパティに反映する。
 * ページ内リンクのオフセット（scroll-padding-top）に利用する。
 */
const syncHeaderHeight = (header) => {
  const apply = () => {
    document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
  };

  apply();
  new ResizeObserver(apply).observe(header);
};

export const initHeader = () => {
  const header = document.getElementById('js-header');
  if (!header) return;

  syncHeaderHeight(header);

  // スクロールしたら背景を敷いて、写真の上でもロゴとメニューが読めるようにする
  const syncScrolled = () => {
    header.classList.toggle(SCROLLED_CLASS, window.scrollY > SCROLLED_OFFSET);
  };

  syncScrolled();
  window.addEventListener('scroll', syncScrolled, { passive: true });

  const button = document.getElementById('js-hamburger--button');
  const menu = document.getElementById('js-header--menu--container');
  if (!button || !menu) return;

  const isDrawer = window.matchMedia(DRAWER_QUERY);

  const setExpanded = (expanded) => {
    button.setAttribute('aria-expanded', String(expanded));
    menu.classList.toggle('is-open', expanded);
    // PC ではナビが常に見えているので inert にしない
    menu.inert = !expanded && isDrawer.matches;
    document.documentElement.classList.toggle(SCROLL_LOCK_CLASS, expanded && isDrawer.matches);
  };

  const isExpanded = () => button.getAttribute('aria-expanded') === 'true';

  setExpanded(false);

  button.addEventListener('click', () => setExpanded(!isExpanded()));

  // メニュー内のリンクを踏んだら閉じる
  menu.addEventListener('click', (event) => {
    if (event.target.closest('a')) setExpanded(false);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && isExpanded()) {
      setExpanded(false);
      button.focus();
    }
  });

  // PC 幅に戻ったらメニューを閉じてスクロールロックも解除する
  isDrawer.addEventListener('change', () => setExpanded(false));
};
